import axiosClient from './axiosClient';
import { RoleModel } from '../Models/roleModel';

const roleService = {
  getAll: () => {
    return axiosClient.get('/Role')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /Role returned 404. Falling back to GET /roles...");
          return axiosClient.get('/roles');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(RoleModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (roleID) => {
    return axiosClient.get(`/Role/${roleID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /Role/${roleID} returned 404. Falling back to GET /roles/${roleID}...`);
          return axiosClient.get(`/roles/${roleID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: RoleModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = RoleModel.toBackend(payload);
    body.roleId = 0;

    return axiosClient.post('/Role', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /Role returned 404. Falling back to POST /roles...");
          return axiosClient.post('/roles', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: RoleModel.toFrontend(raw),
        };
      });
  },

  update: (roleID, payload) => {
    const body = RoleModel.toBackend({ ...payload, roleID });

    return axiosClient.put('/Role', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /Role returned 404. Falling back to PUT /roles...");
          return axiosClient.put('/roles', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: RoleModel.toFrontend(raw),
        };
      });
  },

  remove: (roleID) => {
    return axiosClient.delete(`/Role/${roleID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /Role/${roleID} returned 404. Falling back to DELETE /roles/${roleID}...`);
          return axiosClient.delete(`/roles/${roleID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default roleService;